import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'align-justified', 'AlignJustified', [["path",{"d":"M4 6l16 0"}],["path",{"d":"M4 12l16 0"}],["path",{"d":"M4 18l12 0"}]]);